import { render, staticRenderFns } from "./AffiliateBaseForm.vue?vue&type=template&id=3c21f91e&scoped=true&"
import script from "./AffiliateBaseForm.vue?vue&type=script&lang=js&"
export * from "./AffiliateBaseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c21f91e",
  null
  
)

export default component.exports